import React from 'react';
import CompanyHotelForm from '@app/site/secured/rateshopper/rates/settings/page/competitors/CompanyHotelForm';


const AddNewCompanyHotelPage = React.memo(()=>{


	return <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
		<main>
			<CompanyHotelForm/>
		</main>
	</div>
});

export default AddNewCompanyHotelPage;